import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panels-layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PanelLeft = _resolveComponent("PanelLeft")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_PanelTop = _resolveComponent("PanelTop")!
  const _component_PanelRight = _resolveComponent("PanelRight")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_col, { class: "pa-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "ma-0 pa-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "fit-content ma-0 pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_PanelLeft)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { class: "ma-0 pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_PanelTop)
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { class: "fit-content ma-0 pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_PanelRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}